(function () {
  'use strict';

  /* @ngdoc object
   * @name messageAdmin
   * @description
   *
   */
  angular
    .module('messageInbox', [
      'ui.router'
    ]);
}());
